import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "pa-2",
  style: {"width":"50%"}
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-column ga-1"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "Status:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Created On:", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Published By:", -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Published On:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Order"),
    /*#__PURE__*/_createElementVNode("th", null, "Approvers"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Comment")
  ])
], -1)

import { AssetManagementPlan, User } from "@/classes";
import { useListStore } from "@/store/lists";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DiffGeneral',
  props: {
    plan: {},
    diffPlan: {},
    diff: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const lists = useListStore();
const users = lists.useList<User>("users");

const publishedName = computed(() => {
  return (
    users.value.find((user) => user.id === props.plan?.publisher_id)?.name || ""
  );
});

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.plan)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", null, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.plan.status), 1)
          ]),
          _createElementVNode("span", null, [
            _hoisted_4,
            _createTextVNode(" " + _toDisplayString(_ctx.plan.created.toLocaleString()), 1)
          ]),
          (publishedName.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(publishedName.value), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.plan.published_timestamp)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(_ctx.plan.published_timestamp.toLocaleString()), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (
        _ctx.plan?.asset_management_plan_master &&
        _ctx.plan.asset_management_plan_master.approval_stages.length > 0
      )
      ? (_openBlock(), _createBlock(_component_v_table, {
          key: 1,
          class: "mt-4"
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plan.asset_management_plan_master.approval_stages, (stage) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: stage.id
                }, [
                  _createElementVNode("td", null, _toDisplayString(stage.order + 1), 1),
                  _createElementVNode("td", null, _toDisplayString(stage.formatApprovers(_unref(users))), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_v_tooltip, {
                      location: "bottom",
                      text: stage.status_tooltip
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_chip, _mergeProps({ ref_for: true }, stage.status_tooltip ? props : {}, {
                          color: 
                    stage.status === 'Approved'
                      ? 'green'
                      : stage.status === 'Rejected'
                      ? 'red'
                      : ''
                  ,
                          label: ""
                        }), {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(stage.status), 1)
                          ]),
                          _: 2
                        }, 1040, ["color"])
                      ]),
                      _: 2
                    }, 1032, ["text"])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(stage.comment), 1)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})